import { Action } from 'redux';
import { Moment } from 'moment';

import { DATE_SET_FROM, DATE_SET_TO } from '../../actions/Flight/dates';

export interface AirDatesState {
    from: Moment | null;
    to: Moment | null;
}

const initialState: AirDatesState = {
    from: null,
    to: null
};

export function airDates(state: AirDatesState = initialState, action: Action) {
    switch (action.type) {
        case DATE_SET_FROM: {
            const from = (action as any).from;
            return {
                ...state,
                from
            };
        }
        case DATE_SET_TO: {
            const to = (action as any).to;
            return {
                ...state,
                to
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Flight/airDates.ts